module.exports = __webpack_public_path__ + "img/daynightBig.21425caa.png";